import axios from "axios";

const TOKEN_KEY = "portal_token";

const apiClient = axios.create({
  baseURL: "/api",
  // 不设全局超时：依赖解析和包搜索需要下载远程仓库元数据，耗时较长
  // 需要超时的具体接口（如 upload）在调用时自行设置 timeout
  timeout: 0,
  headers: { "Content-Type": "application/json" },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    // 优先使用后端返回的 message 字段作为错误消息
    const serverMessage = error.response?.data?.message;
    if (serverMessage) {
      error.message = serverMessage;
    }
    if (status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      // 通过自定义事件通知 AuthProvider 清除登录状态，由路由守卫决定是否跳转
      window.dispatchEvent(new CustomEvent("auth:unauthorized"));
    }
    return Promise.reject(error);
  },
);

export default apiClient;
